<template>
    <v-menu v-model="menu" :close-on-content-click="false">
        <template v-slot:activator="{props}">
            <v-btn color="primary" variant="text" icon="mdi-upload-box" v-bind="props" />
        </template>
        <v-card :loading="loading">
            <v-card-title>{{ label }}</v-card-title>
            <v-card-text>
                <v-form ref="form" :disabled="loading">
                    <v-file-input v-model="fileUploadedObject" :label="$t('file_input')" accept=".xlsx" />
                </v-form>
                <div v-if="sampleLink" class="d-flex flex-column ps-8">
                    <a :href="sampleLink" class="text-decoration-none text-primary" data-cy="sample-link" download>
                        {{ $t('download_sample') }}
                    </a>
                    <span class="text--secondary">
                        {{ $t('upload_duration_message') }}
                    </span>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-btn data-cy="upload" :loading="loading" block color="primary" variant="flat" @click="upload">
                    {{ $t('upload') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-menu>
</template>

<script lang="ts">
    import {Component, Emit, Prop, VModel, Vue} from 'vue-facing-decorator'

    @Component
    export class FileUploadModal extends Vue {
        @VModel() menu

        @Prop() label
        @Prop() sampleLink
        @Prop() loading

        fileUploadedObject = null
        result = null

        @Emit()
        async upload() {
            return this.fileUploadedObject
        }

        async close() {
            await this.$nextTick
            this.fileUploadedObject = null
        }
    }

    export default FileUploadModal
</script>
